<template>
  <div
    style="min-width:20vw;min-height:30vh;position:absolute;top:25%;left:40%;z-index:9999;text-align: center;background-color: rgba(7,35,59,.9);border: 1px solid rgba(41, 155, 255, .5)"
    v-if="divVisible">
    <i @touchstart="divClose"  @click="divClose" class="el-icon-close close-btn"></i>
    <!-- 弹窗标题-->
    <div style="margin:15px 0 10px 0;display: inline-block">
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(15, 61, 104, 1), rgba(41, 155, 255, 1));"></div>
      <div class="title"> 编辑区域信息</div>
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(41, 155, 255, 1), rgba(15, 61, 104, 1));"></div>
    </div>
    <!-- 弹窗主体内容 -->
    <div style="height: 100%;width: 100%;">
      <el-row style="height: 50px;width: 500px;margin-top: 4vh">
        <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
          编辑区域背景图片：
        </el-col>
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15"
                v-show="areaBgUrl">
          <div style="text-align: center;position: relative">
            <img :src="$ftpUrl + areaBgUrl"
                 class="upload-img">
            <div class="delete-icon">
                        <span @touchstart="imageRemove" @click="imageRemove">
                            <i class="el-icon-delete"></i>
                        </span>
            </div>
          </div>
        </el-col>
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15"
                v-show="!areaBgUrl">
          <el-upload
            :action="uploadUrl"
            :headers="token"
            :accept="'image/*'"
            :auto-upload="true"
            :on-error="imageChangeError"
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
            drag
            style="margin-bottom: 60px;">
            <i class="el-icon-plus" style="line-height:80px;height: 80px;width: 80px;"></i>
          </el-upload>
        </el-col>
      </el-row>
      <el-row style="margin-top: 9vh;">
        <el-button @touchstart="divClose" @click="divClose">取消</el-button>
        <el-button @touchstart="saveAreaInfo" @click="saveAreaInfo">保存</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>

import {serviceUrl} from "@/utils/request";
import {saveAreaInfo} from "@/network/fire-alarm-panel-network";

export default {
  name: "editAreaBgImgDialog",
  props: ['divVisible','tierId','selectTier'],
  data() {
    return {
      // 弹窗是否展示
      visible: false,
      // 区域背景图片
      areaBgUrl: '',
      // 文件上传地址
      uploadUrl: window.g.gatewayUrl.slice(0, -1) + serviceUrl.deviceService + '/api/upload',
      token: null
    }
  },
  mounted() {
    this.token = {Authorization: 'Bearer' + this.$cookies.get('token')};
  },
  methods: {
    // 成功上传区域背景图
    handleAvatarSuccess(file) {
      this.areaBgUrl = file.data.domain + file.data.url;
    },
    // 上传失败
    imageChangeError() {
      this.$message.error("文件上传失败!请检查网络！")
    },
    divClose() {
      this.$emit("openEditAreaBgImgDialog")
    },
    // 保存区域图片
    saveAreaInfo() {
      let areaInfo = {
        "id": "",
        "bgImage": "",
        "xoffset": "",
        "yoffset": ""
      }
      areaInfo.bgImage = this.areaBgUrl
      // 如果是保存区域背景图片
      areaInfo.id = this.tierId
      console.log('areaInfo',areaInfo)
      if(!this.areaBgUrl){
        this.$message.error("请上传楼层背景图片!")
        return false;
      }
      if(!this.tierId){
        this.$message.error("请选择消防主机楼层!")
        return false;
      }
      saveAreaInfo(areaInfo).then(res => {
        if(res.code==0){
          this.$emit("ChangeInitTree")
          this.$emit("openEditAreaBgImgDialog")
          this.$message.success("保存楼层背景图片成功!")
        }
      })
      this.areaBgUrl = ""
    },
    imageRemove() {
      this.areaBgUrl = '';
      // 重新渲染
      this.$forceUpdate();
    },
  }
}
</script>

<style scoped>

.title {
  display: inline;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px;
}

.close-btn {
  float: right;
  margin-top: 5px;
  margin-right: 8px;
  font-weight: normal;
  color: #FFFFFF;
}

.close-btn:hover {
  cursor: pointer;
}

.title-line {
  width: 50px;
  height: 2px;
  display: inline-block;
  margin-bottom: 5px;
  border-radius: 15px;
}

.tierDiv {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center
}

.tierDiv:hover {
  background-color: rgb(26, 107, 179) !important;
  cursor: pointer;
}

.asideRight {
  overflow: auto;
  width: 100%;
}

.upload-img {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 0;
  top: 0;
}

.upload-img:hover + .delete-icon {
  display: block;
}

.delete-icon:hover {
  display: block;
}

.delete-icon {
  line-height: 80px;
  height: 80px;
  width: 80px;
  position: center;
  display: none;
}

::v-deep .el-drawer {
  background-color: rgb(11, 50, 82);
  border-radius: 0 8px 8px 0;
}

::v-deep .asideRight .el-drawer {
  background-color: rgb(11, 50, 82);
  border-radius: 8px 0 0 8px;
}

::v-deep .asideRight .el-drawer__wrapper {
  width: 20%;
  left: unset;
}

::v-deep .el-drawer__header {
  color: white;
}

::v-deep .el-drawer__body {
  overflow-y: auto;
}


</style>
